import type { ReactNode } from 'react'
import { ChevronRight } from 'lucide-react'

/** Right-rail association card (Opportunities, Properties, Files, Key Dates, Tickets…). */
export function AssociationCard({
  title, count, action, children, icon,
}: { title: ReactNode; count?: number; action?: ReactNode; children: ReactNode; icon?: ReactNode }) {
  return (
    <section className="assoc-card">
      <header className="assoc-head">
        <div className="assoc-head-left">
          {icon && <span className="assoc-icon">{icon}</span>}
          <span className="assoc-title label">{title}</span>
          {count != null && <span className="assoc-count">{count}</span>}
        </div>
        {action}
      </header>
      <div className="assoc-body">{children}</div>
    </section>
  )
}

/** A single linked row inside an association card. */
export function AssocRow({ primary, secondary, meta, onClick }: { primary: ReactNode; secondary?: ReactNode; meta?: ReactNode; onClick?: () => void }) {
  return (
    <button className="assoc-row" onClick={onClick} disabled={!onClick}>
      <div className="assoc-row-main">
        <div className="assoc-row-primary truncate">{primary}</div>
        {secondary && <div className="assoc-row-secondary truncate">{secondary}</div>}
      </div>
      {meta && <div className="assoc-row-meta">{meta}</div>}
      {onClick && <ChevronRight size={14} className="assoc-row-chev" />}
    </button>
  )
}
